module.exports = __webpack_public_path__ + "img/Cảng Hải Phòng - .4db92d76.jpg";